import { Path } from 'react-hook-form';

export interface FormComponentProps<T> {
  name: Path<T>;
  readonly?: boolean;
}

export enum EUserRole {
  ADMINISTRATOR = 'Administrator',
  STANDARD_USER = 'Standard User',
  ADVANCED_USER = 'Advanced User',
  SUPERVISOR_USER = 'Supervisor User',
  TEAM_LEADER = 'Team Leader',
  READONLY_USER = 'Read Only User'
}

export type UserApplication = {
  applicationName: string;
  applicationUrl: string;
  active: boolean;
};

export type BaseUserInfo = {
  user: string;
  userType: 'INTERNAL' | 'EXTERNAL';
  organisation: string;
  expires: number;
  applications: UserApplication[];
};

export type UserInfoResponse = BaseUserInfo & { permissions: Record<string, string> };
export type UserInfo = BaseUserInfo & { role: EUserRole };
